import { createContext, useContext } from "react";

type FilterChipVariant = "default" | "toolbar";

const FilterChipVariantContext = createContext<FilterChipVariant>("default");

export const FilterChipVariantProvider = FilterChipVariantContext.Provider;

export const useFilterChipVariant = () => useContext(FilterChipVariantContext);
